import styled from 'styled-components';

import { breakpoints } from '../constants';

export const ButtonWrapper = styled.div`
  padding-top: 40px;
  margin-bottom: 110px;
  font-size: 16px;

  @media (min-width: ${breakpoints.tablet}) {
    button {
      width: 140px;
      height: 50px;
      line-height: 22px;
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-bottom: 0;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  text-align: center;
  z-index: 1;

  @media (min-width: ${breakpoints.tablet}) {
    padding-top: 4%;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-top: 6%;
    padding-bottom: 6%;
  }
`;

export const Description = styled.div`
  opacity: 0.7;
  h1 {
    font-weight: 400 !important;
    color: rgb(26, 46, 59);
  }
`;
